<app-sidebar-base>
    <div sidebar>
        @for (category of categories; track category.id) {
            <app-sidebar-section
                [titleSection]="category.title | translate"
                [collapsible]="true"
                [hasSelected]="hasSelected(category)"
                [hasChanges]="hasChanges(category)"
                [changesLabel]="'SETTINGS.HUB.UNSAVED_CHANGES_MARK' | translate"
                [expandTrigger]="hasSelected(category) ? navigationCount : null">
                @for (subcategory of category.subcategories; track subcategory.id) {
                    <app-sidebar-item
                        [isSelected]="subcategory.id === selectedSubcategoryId"
                        (click)="subcategorySelect.emit(subcategory.id)">
                        <mat-icon start>{{ subcategory.icon }}</mat-icon>
                        <span title>{{ subcategory.title | translate }}</span>
                        @if (changedSubcategoryIds.has(subcategory.id)) {
                            <span end data-unsaved role="img" class="tw-block tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-red-600"
                                [attr.aria-label]="'SETTINGS.HUB.UNSAVED_CHANGES_MARK' | translate"
                                [attr.title]="'SETTINGS.HUB.UNSAVED_CHANGES_MARK' | translate"></span>
                        }
                    </app-sidebar-item>
                }
            </app-sidebar-section>
        }
    </div>
</app-sidebar-base>
